const USER_CONFIG_CLIPBOARD_KEY = "user-config-clipboard";

export const userConfigClipboardLocalStorage = {
  get(): UpdateUserConfigDTO | null {
    const raw = localStorage.getItem(USER_CONFIG_CLIPBOARD_KEY);
    return raw ? JSON.parse(raw) : null;
  },
  set(config: UpdateUserConfigDTO) {
    localStorage.setItem(USER_CONFIG_CLIPBOARD_KEY, JSON.stringify(config));
  },
};

export const authenticationLocalStorage = {
  clear: () => {
    localStorage.removeItem("token");
    localStorage.removeItem("logged-user");
  },

  get token() {
    return localStorage.getItem("token");
  },
  setToken: (value: string) => {
    localStorage.setItem("token", value);
  },

  get loggedUser(): User | null {
    const loggedUser = localStorage.getItem("logged-user");
    return loggedUser ? JSON.parse(loggedUser) : null;
  },
  setLoggedUser: (user: User) => {
    localStorage.setItem("logged-user", JSON.stringify(user));
  },
};
